<template>
  <div>
    <the-headersider></the-headersider>

    <base-card>

  
    
    <form @submit.prevent="createInvoice">
      <div class="form-control">
        <label for="name"> Invoice Date </label>
        <input  class="form-control" type="date" id="invoice_date" v-model="formData.invoice_date" />
      </div>
      
      <div class="form-control">
      <div class="field">
          <label class="label">court</label>
          <div class="select">
            <select v-model="formData.vat_percentage">
              <option disabled value="">Select percentage</option>
                <!-- <select name="vat" class="form-control" v-model="formData.vat"> -->
                <option value="0">0%</option>

                <option value="16">16%</option>
            </select>
          </div>
        </div>
        </div>
       
      <!-- <div class="form-control">
        <label for="registered_by"> reg by</label>
        <input type="text"  id="registered_by" v-model="formData.registered_by" />
      </div> -->
  
       
      
      <base-button>Submit</base-button>
      <br>
      <br>
      <router-link to="/">Go back Home</router-link>
    </form>
  
      
    </base-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: "",

      formData: {
        invoice_date: "",
        client_id: this.$route.params.client,
        vat_percentage: "",
      },
    };
  },
  computed: {
    courts() {
      return this.$store.getters.courts;
    },
  },
  created() {
    this.$store.dispatch("LoadCourts");
  },
  //  mounted() {
  // let user = localStorage.getItem('user');
  // this.user = JSON.parse(user)

  // },
  methods: {
    async createInvoice() {
      const response = await axios.post(
        "https://api.roberms.com/garbage/create/invoice/",
        this.formData
      );
      console.log(response);

      this.$router.replace("/invoices/client/" + this.$route.params.client);
      console.log(this.formData);
    },
  },
};
</script>
